import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import QuestionBox from "../../../components/QuestionBox";
import BigTextBox from "../../../components/BigTextBox";
import Button from "../../../components/Button";
import {
  selectPageData,
  navigateNext,
} from "../../../../../../../../redux/reducers/navigationSlice";
import TOTFeedbackModal from "../../../../TOT-2/components/TOTFeedbackModal";

import { adminData } from "../../../../../../../../redux/reducers/adminReducer";
import {
  userAnswer,
  saveActivity,
} from "../../../../../../../../redux/reducers/userAnswersReducer";
import {
  getActivityDraft,
  saveActivityDraft,
} from "../../../utils/activityDrafts";
import adaptability from "../../../../../../../../assets/resilience-grit-images/adaptability.png";

function WeekTwoPage2() {
  const dispatch = useDispatch();
  const pageData = useSelector(selectPageData);
  const adminDatas = useSelector(adminData);
  const userAnswers = useSelector(userAnswer);
  const [myAnswer, setMyAnswer] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [showFeedback, setShowFeedback] = useState(false);
  const handleCloseFeedback = () => {
    setShowFeedback(false);
    dispatch(navigateNext()); // Navigate after closing the modal
  };

  useEffect(() => {
    if (!userAnswers) return;
    const response = userAnswers?.activities?.find(
      (item) => item.page === pageData.id,
    );
    const draftAnswer = getActivityDraft(userAnswers, pageData.id);
    setMyAnswer(response?.answer ?? draftAnswer ?? "");
    return () => {};
  }, [userAnswers]);

  const saveUserInput = () => {
    if (!adminDatas.isAdmin && !myAnswer) {
      setErrorMessage("Oops! Please enter a valid input!");
      return false;
    }

    setErrorMessage(""); // Clear error if input is valid
    // Allow flow admin to proceed without input but do not dispatch answer
    if (adminDatas.isAdmin) return true;
    dispatch(
      saveActivity({
        page: pageData.id,
        answer: myAnswer,
      }),
    );

    // Show feedback modal instead of navigating immediately
    setShowFeedback(true);
    // return true;
  };

  const handleInputChange = (e) => {
    setErrorMessage("");
    const nextAnswer = e.target.value;
    setMyAnswer(nextAnswer);
    saveActivityDraft(userAnswers, pageData.id, nextAnswer);
  };

  return (
    <>
      <QuestionBox extraStyle="bg-custom-blue">
        <div className="d-flex gap-3 flex-column flex-md-row flex-md-nowrap align-items-start mt-5">
          <h2 className="text-blue fs-1 mb-0 flex-shrink-0 tot-question-text">
            Question:
          </h2>

          <div className="d-flex flex-column flex-grow-1 min-w-0 tot-question-text mb-5">
            <h2 className="text-gray fs-1 mb-2 ">
              Type in what you remember from last week.
            </h2>
          </div>
        </div>
        <BigTextBox handleChange={handleInputChange} value={myAnswer} />
      </QuestionBox>
      {errorMessage && <div className="text-danger">{errorMessage}</div>}
      <div className="d-flex justify-content-center gap-96px mt-4 gap-4">
        <Button text="Prev" />
        <Button text="Next" customOnClick={saveUserInput} />
      </div>
      <TOTFeedbackModal show={showFeedback} onHide={handleCloseFeedback}>
        <p className="text-blue mb-3">Thank you for reflecting.</p>
        <p className="text-blue">
          Revisiting what we learned helps strengthen connections between new
          and previous ideas. As we continue, you will see how the concepts from
          last week connect directly to today’s focus.
        </p>
      </TOTFeedbackModal>
    </>
  );
}

export default WeekTwoPage2;
